<template>
	<v-list density="compact">
		<v-list-item class="list-ChartContextMenu" @click="onContextMenuAction($event)">
			<v-list-item-title>{{ label }}</v-list-item-title>
		</v-list-item>
	</v-list>
</template>

<script>
export default {
	computed: {
		label() {
			// If no picked point -> show Cancel; otherwise show Undo
			const count = this.$store.getters.viewer.getPickedPointCount?.();
			return count && count > 0 ? this.$t("Undo") : this.$t("CANCEL");
		},
	},
	methods: {
		onContextMenuAction(e) {
			e.preventDefault();
			const count = this.$store.getters.viewer.getPickedPointCount?.();
			switch (count && count > 0 ? "undo" : "cancel") {
				case "undo":
					this.$store.getters.viewer.undoLastPickedPoint?.();
					break;
				case "cancel":
					this.$store.getters.viewer.cancelSolidMeshConstruction?.();
					break;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.list-ChartContextMenu:hover {
  background-color: #0064ba !important;
}
</style>